import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "permitions" }

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import moment from "moment";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import AppLists from "@/components/ui-kit/lists/AppLists.vue";
import { CommonEntityRecord } from "@/models/interfaces/common";
// import ProjectAccessRulesTab from "../permitions/ProjectAccessRulesTab.vue";
import AnalyticPermitionsTab from "./AnalyticPermitionsTab.vue";
import { EntityRulesContainer } from "@/models/interfaces/access/entity-rules";
import { AccessApi } from "@/ api/AccessApi";

const PROJECT_SEGMENT = 0;


export default /*@__PURE__*/_defineComponent({
  __name: 'AnalyticPermitionModal',
  emits: ["saved"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const route = useRoute();

const $modal = ref<typeof BaseModal | null>(null);
const isActive = ref(false);
const $lists = ref<InstanceType<typeof AppLists> | null>(null);

const rulesContainer = ref<EntityRulesContainer | null>(null);

const activeTab = ref<number>(0);
const isLoading = ref(false);
const entitiesIdRef = ref<number[]>([]);
const entitiesType = ref<number>(0);
const tags = ref<CommonEntityRecord[]>([]);

const formatDate = (date: string | undefined | null) => {
  if (!date) return "";
  return moment(date).format("HH:mm DD.MM.YYYY");
};

watch(activeTab, () => {
  $lists.value?.close();
});

const onOpen = async (selectedIds: number[], destType: number) => {
  try {
    entitiesIdRef.value = selectedIds;
    entitiesType.value = destType
    // clientIdRef.value = projectId;
    isLoading.value = true;
    activeTab.value = 0;
    $modal.value?.onOpen();
    isActive.value = true;
    await refreshRules();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onClose = () => {
  isActive.value = false;
  $modal.value?.onClose();
};

const onSave = () => {
  emit("saved");
  onClose();
};

onMounted(() => {
  window.addEventListener("keydown", handleEsc, true);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEsc, true);
});

const handleEsc = async (e: KeyboardEvent) => {
  if (e.key !== "Escape") {
    return;
  }
  if (!isActive.value) {
    return;
  }

  e.stopPropagation();
  $modal.value?.onClose();
};

// watch(projectPage.project?.RuleAccess,() => { if(projectPage.project?.RuleAccess ==1) tabs.value = [
//   { id: 0, title: "Информация о проекте", slotName: "info" },
//   { id: 1, title: "Права доступа", slotName: "rules" },
// ];})

__expose({ onOpen });

const refreshRules = async () => {
  try {
    const rulesGiver =
      entitiesType.value === PROJECT_SEGMENT
        ? await AccessApi.getProjectAccessRules(entitiesIdRef.value[0])
        : await AccessApi.getClientAccessRules(entitiesIdRef.value[0]);
    rulesContainer.value = rulesGiver?.Container ?? null;
  } catch (e) {
    console.error(e);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    loading: isLoading.value,
    width: "900px",
    height: "800px",
    onOnClose: _cache[0] || (_cache[0] = ($event: any) => (isActive.value = false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AnalyticPermitionsTab, {
          container: rulesContainer.value,
          "entity-ids": entitiesIdRef.value,
          "can-edit": true,
          onSave: onSave,
          onCancel: onClose,
          type: entitiesType.value === PROJECT_SEGMENT ? 'project' : 'client'
        }, null, 8, ["container", "entity-ids", "type"])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})